import { isNumber, reduce } from 'lodash';
import moment from 'moment';

function fallbackCopyTextToClipboard(text, success, fail) {
    var textArea = document.createElement('textarea');
    textArea.value = text;

    textArea.style.top = '0';
    textArea.style.left = '0';
    textArea.style.position = 'fixed';

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
        var successful = document.execCommand('copy');
        successful ? success() : fail();
    } catch (err) {
        fail(err);
    }

    document.body.removeChild(textArea);
}

function copyTextToClipboard({ text, success = () => '', fail = () => '' }) {
    if (!navigator.clipboard) {
        fallbackCopyTextToClipboard(text, success, fail);
        return;
    }
    navigator.clipboard.writeText(text).then(success, fail);
}

// Debounce function to delay execution until the input stabilizes
function debounce(func, delay) {
    let timeoutId;
    return function (...args) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            func.apply(this, args);
        }, delay);
    };
}

const getSize = (size) => (isNumber(size) ? `${size}px` : size);

const isWeekend = (date) => moment(date).day() === 0 || moment(date).day() === 6;
const isToday = (date) => moment(date).isSame(moment(), 'day');
const isBefore = (date) => moment(date).isBefore(moment().subtract(12, 'hours'));

const numberPrettier = (value = '') => {
    value = String(value).trim();
    const numericValue = value.replace(/[^0-9.]/g, '');
    const number = parseFloat(numericValue);

    if (isNaN(number)) {
        return '';
    }

    const rounded = Math.round(number * 100) / 100;
    const [integerPart, decimalPart] = String(rounded).split('.');

    const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    return decimalPart !== undefined ? `${formattedIntegerPart}.${decimalPart}` : formattedIntegerPart;
};

const getColumnWidth = (selector) => {
    const column = document.querySelector(selector);
    if (column) {
        return column.offsetWidth;
    }
    throw new Error('Element not found');
};

const getUnAvailableRoomInfos = (numberArr) => {
    return reduce(
        numberArr,
        (acc, val, i) => {
            if (val === 0) {
                const prev = acc[acc.length - 1];
                if (prev && prev.index + prev.count === i) {
                    prev.count++;
                } else {
                    acc.push({ index: i, count: 1 });
                }
            }
            return acc;
        },
        [],
    );
};

export { copyTextToClipboard, debounce, getSize, isWeekend, isToday, isBefore, numberPrettier, getColumnWidth, getUnAvailableRoomInfos };
